import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Teams from '../../api/team'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay } from 'swiper';

import sImg3 from '../../images/icons/icon_linkedin.svg'

const TeamPage = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <Fragment>
            <main className="page_content about-page">
                
                {/* 👇 KUNCINYA DI SINI BRAY: Kasih overflow: 'hidden' biar ga jebol ke samping 👇 */}
                <section className="team_section section_space" style={{ overflow: 'hidden' }}>
                    
                    <style>{`
                        .swiper-bray .swiper-wrapper {
                            display: flex !important;
                            align-items: stretch !important;
                        }
                        .swiper-bray .swiper-slide {
                            height: auto !important;
                            display: flex !important;
                        }
                        .team_carousel .team_block {
                            height: 100% !important;
                        }
                    `}</style>

                    <div className="container">
                        <div className="heading_block text-center">
                            <h2 className="heading_text mb-0">
                                Our Core Team
                            </h2>
                        </div>

                        <div className="team_carousel">
                            <Swiper
                                className="swiper-bray"
                                modules={[Autoplay]}
                                autoplay={{ delay: 2500, disableOnInteraction: false }}
                                loop={true}
                                spaceBetween={30}
                                allowTouchMove={true}
                                centeredSlides={true}
                                pagination={{ clickable: true }}
                                speed={800}
                                breakpoints={{
                                    576: { slidesPerView: 2 },
                                    1025: { slidesPerView: 3 },
                                }}
                            >
                                {Teams.slice(0, 6).map((team, tm) => (
                                    <SwiperSlide key={tm}>
                                        <div className="team_block" style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>

                                            <div className="team_member_image" style={{ height: '320px', width: '100%', overflow: 'hidden', marginBottom: '25px' }}>
                                                <div className="image_wrap" style={{ height: '100%', width: '100%' }}>
                                                    <img 
                                                        src={team.tImg} 
                                                        alt={team.name} 
                                                        style={{
                                                            height: '100%',
                                                            width: '100%',
                                                            objectFit: 'contain', 
                                                            objectPosition: 'bottom center', 
                                                            display: 'block'
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="team_member_info" style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                                
                                                <h3 className="team_member_name" style={{ textAlign: 'center', margin: '0 0 5px 0' }}>
                                                    <Link onClick={ClickHandler} to={`/`}>{team.name}</Link>
                                                </h3>
                                                
                                                <h4 className="team_member_designation" style={{ textAlign: 'center', margin: '0' }}>
                                                    {team.title}
                                                </h4>
                                                
                                                <ul className="social_icons_block unordered_list justify-content-center" style={{ marginTop: 'auto', paddingTop: '20px' }}>
                                                    <li>
                                                        <a href={team.linkedin} target="_blank" rel="noopener noreferrer">
                                                            <img src={sImg3} alt="Icon Linkedin" />
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>

                    </div>
                </section>
            </main>
        </Fragment>
    )
};

export default TeamPage;
